//import React, { useState } from "react";
import background from "../Assets/login.svg";
import "./MoboPage.css";
// import VendorLogin from "./VendorLogin";
// import WelcomePage from "../WelcomePage/WelcomePage";
import VendorLoginform from "../Login/Loginform";
// import Signup from "../Signup/VendorSignup";
// import OnboardingForm from "../onboardingForm/OnboardingForm";
function NewVendorlLogin() {
  // const [currentView, setCurrentView] = useState("WelcomePage");
  // const handleViewChange = (view) => {
  //   setCurrentView(view);
  // };
  return (
    <div style={{ overflow: "hidden" }}>
      <div className="background-img-vendor">
        <img src={background} alt="Left Design" />
      </div>
      <div className="content-login-signup-welcome">
        {/* {currentView === "WelcomePage" && (
          <WelcomePage handleViewChange={handleViewChange} />
        )}
        {currentView === "signup" && (
          <Signup handleViewChange={handleViewChange} />
        )} */}
        <VendorLoginform />
        {/* {currentView === "login" && (
        )} */}
        {/* {currentView === "Onboarding" && <OnboardingForm />} */}
      </div>
    </div>
  );
}

export default NewVendorlLogin;
